import {EvPageLoadingSpinner} from '../../components/ev-page-loading-spinner';
import {CustomerCommentBox} from './customer-comment-box';
import {useCustomerCommentsQuery} from './use-customer-comments-query';

interface Props {
  customerId: number;
}

export function CustomerCommentList({customerId}: Props) {
  const {comments, commentIsPending} = useCustomerCommentsQuery(customerId);

  if (commentIsPending) {
    return <EvPageLoadingSpinner/>;
  }

  if (comments.length === 0) {
    return <div className="whitebox whitebox-margin">Keine Kommentare vorhanden</div>;
  }

  return <>
    {comments.map(comment => <CustomerCommentBox key={comment.id} comment={comment}/>)}
  </>;
}
